import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStop = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 7C12.4142 7 12.75 7.33579 12.75 7.75V12.25C12.75 12.6642 12.4142 13 12 13C11.5858 13 11.25 12.6642 11.25 12.25V7.75C11.25 7.33579 11.5858 7 12 7Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.32754 1.46967C7.46819 1.32902 7.65895 1.25 7.85786 1.25H16.1421C16.341 1.25 16.5318 1.32902 16.6725 1.46967L22.5303 7.32754C22.671 7.46819 22.75 7.65895 22.75 7.85786V16.1421C22.75 16.341 22.671 16.5318 22.5303 16.6725L16.6725 22.5303C16.5318 22.671 16.341 22.75 16.1421 22.75H7.85786C7.65895 22.75 7.46819 22.671 7.32753 22.5303L1.46967 16.6725C1.32902 16.5318 1.25 16.341 1.25 16.1421V7.85786C1.25 7.65895 1.32902 7.46819 1.46967 7.32754L7.32754 1.46967ZM8.16853 2.75L2.75 8.16853L2.75 15.8315L8.16852 21.25H15.8315L21.25 15.8315V8.16852L15.8315 2.75L8.16853 2.75Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgStop;
